import React from 'react';
import { ChipProps } from '@mui/material';
import { useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';
import DSChip from './DSChip';

interface DSLabelChipProps extends Omit<ChipProps, 'onDelete'> {
  label: string;
  onDelete?: (event: React.MouseEvent) => void;
}

const DSLabelChip = ({ label, onDelete, ...props }: DSLabelChipProps) => {
  const { spacing, palette } = useTheme();

  return (
    <DSChip
      label={label}
      onDelete={onDelete}
      deleteIcon={
        <Close
          sx={{
            fontSize: '16px',
            color: palette.text.primary,
            '&:hover': {
              color: palette.text.secondary,
            },
          }}
        />
      }
      {...props}
      sx={{
        backgroundColor: 'transparent',
        color: palette.common.white,
        padding: `${spacing(0.5)} ${spacing(1)}`,
        border: `1px solid ${palette.common.white}`,
        '& .MuiChip-label': {
          padding: `${spacing(0.5)} ${spacing(0.5)}`,
        },
        '& .MuiChip-deleteIcon': {
          margin: 0,
          marginLeft: spacing(0.5),
        },
        ...props.sx,
      }}
    />
  );
};

export default DSLabelChip;
